const setThreadRunState = ({ threadId, runId, state, composerLane, blockerCode, blockerReason, blockerMessage, startedAt, completedAt, durationMs, activeDurationMs, blockedDurationMs } = {}) => {
  return {
    type: 'pieveSetThreadRunState',
    payload: { threadId, runId, state, composerLane, blockerCode, blockerReason, blockerMessage, startedAt, completedAt, durationMs, activeDurationMs, blockedDurationMs }
  };
};

export default setThreadRunState;
